import { render, staticRenderFns } from "./TangshiSongci.vue?vue&type=template&id=2265279b&scoped=true&"
import script from "./TangshiSongci.vue?vue&type=script&lang=js&"
export * from "./TangshiSongci.vue?vue&type=script&lang=js&"
import style0 from "./TangshiSongci.vue?vue&type=style&index=0&id=2265279b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2265279b",
  null
  
)

export default component.exports